import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  BankOutlined,
  TeamOutlined,
  ArrowRightOutlined,
  SearchOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

import "./jobListingEventsPage.scss";
import JobListingsPageHeader from "../jobListingPageHeader";
import useNuJobsStore from "../../../store/nujobs.store";

const JobListingEventsPage = () => {
  const navigate = useNavigate();

  const [eventType, setEventType] = useState("ALL");
  const [searchText, setSearchText] = useState("");
  const { upcomingEvents,nuJobsUpcomingEvents,nuJobsGetJDandEvent } = useNuJobsStore();

  useEffect(() => {
      // Fetch hiring companies from the store or API
      // This is just a placeholder; replace with actual data fetching logic
      // setHiringCompanies(fetchedCompanies);
      nuJobsUpcomingEvents(0)
    }, []);

  // Replace this later with backend API data
  const events = [
    {
      id: 1,
      title: "Walk-in Drive – Software Engineers",
      company: "ABC Technologies",
      hiringType: "DIRECT",
      eventType: "WALK_IN",
      date: "12 Oct 2026",
      time: "10:00 AM – 4:00 PM",
      location: "Bengaluru, Karnataka",
      mode: "In Person",
      roles: "Java Developer, React Developer, QA Engineer",
      experience: "2 – 6 Years",
    },
    {
      id: 2,
      title: "Virtual Hiring Drive – Cloud & DevOps",
      company: "XYZ Consulting",
      hiringType: "CONSULTANCY",
      eventType: "VIRTUAL",
      date: "15 Oct 2026",
      time: "11:00 AM – 3:00 PM",
      location: "Online",
      mode: "Virtual",
      roles: "DevOps Engineer, AWS Engineer, Cloud Architect",
      experience: "3 – 8 Years",
    },
    {
      id: 3,
      title: "Walk-in Drive – Embedded Engineers",
      company: "Tech Systems India",
      hiringType: "DIRECT",
      eventType: "WALK_IN",
      date: "18 Oct 2026",
      time: "9:30 AM – 2:00 PM",
      location: "Pune, Maharashtra",
      mode: "In Person",
      roles: "Embedded C, Linux Device Drivers, BSP",
      experience: "2 – 10 Years",
    },
    {
      id: 4,
      title: "Technology Job Fair 2026",
      company: "Multiple Employers",
      hiringType: "MULTIPLE",
      eventType: "JOB_FAIR",
      date: "24 Oct 2026",
      time: "10:00 AM – 5:00 PM",
      location: "Hyderabad, Telangana",
      mode: "In Person",
      roles: "Software, Cloud, Data, QA & Support Roles",
      experience: "Freshers – 10 Years",
    },
  ];

  const filteredEvents = useMemo(() => {
    return upcomingEvents?.filter((event) => {
      const matchesType =
        eventType === "ALL" || event.eventtype === eventType;

      const search = searchText.trim().toLowerCase();

      const matchesSearch =
        !search ||
        event.title.toLowerCase().includes(search) ||
        event.company.toLowerCase().includes(search) ||
        event.city.toLowerCase().includes(search) ||
        event.roles.toLowerCase().includes(search);

      return matchesType && matchesSearch;
    });
  }, [eventType, searchText,upcomingEvents]);


  const handleNavigate = (qhoid, qhjid) => {
    //because while doing viewevent, needs to have jd from backend
    var source = "viewevent"
    navigate(`/nujobsViewJobsContainerOpenSearch/${source}/${qhjid}/${qhoid }`);
  };

  const handleViewEvent = (event) => {
    nuJobsGetJDandEvent(event.qhoid,event.qhcompanyjid,handleNavigate );
  };
  return (
    <div className="nujobs-events-page">
      <JobListingsPageHeader/>  
      {/* HERO */}
      <section className="events-hero">
        <div className="events-hero-content">
          <div className="events-hero-icon">
            <CalendarOutlined />
          </div>

          <h1>Hiring Events</h1>

          <p>
            Discover walk-in drives, virtual hiring events and job fairs
            from employers and recruitment partners.
          </p>
        </div>
      </section>

      {/* FILTER / SEARCH */}
       
      <section className="events-filter-section">
        <div className="events-filter-container">

          <div className="event-type-tabs">
            <button
              className={eventType === "ALL" ? "active" : ""}
              onClick={() => setEventType("ALL")}
            >
              All Events
            </button>

            <button
              className={eventType === "Walkin Drive" ? "active" : ""}
              onClick={() => setEventType("Walkin Drive")}
            >
              Walk-in Drives
            </button>

            <button
              className={eventType === "Virtual Drive" ? "active" : ""}
              onClick={() => setEventType("Virtual Drive")}
            >
              Virtual Drives
            </button>

            <button
              className={eventType === "JobFair" ? "active" : ""}
              onClick={() => setEventType("JobFair")}
            >
              Job Fairs
            </button>
            <button
              className={eventType === "Hackathon" ? "active" : ""}
              onClick={() => setEventType("Hackathon")}
            >
              Hackathons
            </button>            
          </div>

          <div className="event-search">
            <SearchOutlined />

            <input
              type="text"
              placeholder="Search events, skills, companies or locations"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

        </div>
      </section>

      {/* EVENTS */}
      <section className="events-content">

        <div className="events-section-header">
          <div>
            <h2>Upcoming Hiring Events</h2>
            <p>
              Explore upcoming opportunities and connect directly with
              hiring companies.
            </p>
          </div>

          <span className="event-count">
            {filteredEvents?.length} Events
          </span>
        </div>

        {filteredEvents?.length > 0 ? (
          <div className="events-grid">

            {filteredEvents?.map((event) => (
              <div className="event-card" key={event.id}>

                <div className="event-card-top">

                  <div className="event-date-box">
                    <CalendarOutlined />
                    <span>{event.startdate}</span>
                  </div>

                  <div
                    className={`hiring-type ${
                      event.hiringType === "DIRECT"
                        ? "direct"
                        : event.hiringType === "CONSULTANCY"
                        ? "consultancy"
                        : "consultancy"
                    }`}
                  >
                    {event.hiringType === "DIRECT"
                      ? "Direct Employer"
                      : event.hiringType === "CONSULTANCY"
                      ? "Recruitment Partner"
                      : "Recruitment Partner"}
                  </div>

                </div>

                <div className="event-card-body">

                  <h3>{event.eventname}</h3>

                  <div className="event-company">
                    <BankOutlined />
                    <span>{event.companyname}</span>
                  </div>

                  <div className="event-details">

                    <div className="event-detail">
                      <ClockCircleOutlined />

                      <div>
                        <span className="label">Time</span>
                        <span className="value">{event.starttime}</span>
                      </div>
                    </div>

                    <div className="event-detail">
                      {event.mode === "Virtual" ? (
                        <VideoCameraOutlined />
                      ) : (
                        <EnvironmentOutlined />
                      )}

                      <div>
                        <span className="label">
                          {event.mode === "Virtual"
                            ? "Mode"
                            : "Location"}
                        </span>

                        <span className="value">
                          {event.city}
                        </span>
                      </div>
                    </div>

                    <div className="event-detail">
                      <TeamOutlined />

                      <div>
                        <span className="label">Experience</span>
                        <span className="value">
                          {event.minexp}-{event.maxexp}
                        </span>
                      </div>
                    </div>

                  </div>

                  <div className="event-roles">
                    <span className="label">Hiring For</span>
                    <p>{event.jobtitle} </p>
                  </div>

                </div>

                <div className="event-card-footer">

                  <span className="event-mode">
                    {event.eventtype }
                  </span>

                  <button
                    className="view-event-btn"
                    onClick={() => handleViewEvent(event)}
                  >
                    View Details
                    <ArrowRightOutlined />
                  </button>

                </div>

              </div>
            ))}

          </div>
        ) : (
          <div className="no-events">
            <CalendarOutlined />

            <h3>No events found</h3>

            <p>
              Try changing your search or event type.
            </p>
          </div>
        )}

      </section>

      {/* INFO SECTION */}
      <section className="events-info-section">

        <div className="events-info-content">

          <div>
            <h2>Looking for your next opportunity?</h2>

            <p>
              NuJobs brings hiring events and job opportunities from
              multiple employers onto one platform.
            </p>
          </div>

          <button
            onClick={() => navigate("/nujobs")}
            className="browse-jobs-btn"
          >
            Browse Jobs
            <ArrowRightOutlined />
          </button>

        </div>

      </section>

    </div>
  );
};

export default JobListingEventsPage;